import React from 'react';
import Animation from '../../../../common/animation';
import { Button } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { ActionGroup, ActionGroupContent } from './ActionGroupButtons.styles';

const ActionGroupButtons = ({
  onClickBack,
  onClickNext,
  nextButtonActived,

  disabledBtnBack = false,
  btnBackShow = false,
  btnCancelShow = true,
  btnNextShow = true,
  isLoading = false,
}) => {
  const backText = useGlotaT('spa.common.back');
  const cancelText = useGlotaT('spa.common.cancel');
  const nextText = useGlotaT('spa.common.next');

  return (
    <ActionGroup>
      <ActionGroupContent>
        {btnBackShow && (
          <Button
            color="primary"
            size="md"
            onClick={onClickBack}
            disabled={disabledBtnBack}
          >
            {backText}
          </Button>
        )}

        {btnCancelShow && (
          <Button color="danger" size="md" onClick={onClickBack}>
            {cancelText}
          </Button>
        )}

        {isLoading && (
          <div>
            <Animation icon="loading" size={'lg'} />
          </div>
        )}

        {btnNextShow && (
          <Button
            disabled={nextButtonActived}
            color="primary"
            size="md"
            onClick={onClickNext}
          >
            {nextText}
          </Button>
        )}
      </ActionGroupContent>
    </ActionGroup>
  );
};

export default ActionGroupButtons;
